<template>
  <div id="index"> 
      <el-container>
        <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
          <el-main>
            <el-row :gutter="24">
              <el-col :xs="1" :sm="2" :lg="4" v-html="'&nbsp;'"></el-col>
              <el-col :xs="24" :sm="20" :lg="16">
                <div class="BeingSoon">
                  <h4 style="color: green">修改密码成功！</h4>
                  <!--  如果是修改密码失败或者其他报错提示，color：red -->
                  <span>即将在5秒后自动跳转回XXX页面</span>
                  <!-- 提示文字，例如报错的详细内容，或者，修改成功后的文字“即将在5秒后自动跳转回XXX页面”类似文字等 -->
                </div>
              </el-col>
              <el-col :xs="1" :sm="2" :lg="4"> &nbsp; </el-col>
            </el-row>
          </el-main>
        </el-scrollbar>
      </el-container> 
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "index",
  data() {
    return {};
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
    navselected: (state) => state.adminleftnavnum,
  }),
  methods: {
    openNotice() {
      this.$notify({
        title: "警告",
        message: "这是一条警告的提示消息",
        type: "warning",
      });
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
  },
};
</script>

<style scrop>
.BeingSoon {
  min-height: 100px;
  
}
.BeingSoon h4 {
  font-size: 24px;
  text-align:center;
  
}
</style>